import React from 'react';
import URLSearchParams from 'url-search-params';
import {inject} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import {withRouter} from 'react-router-dom';

const CREATE_USER = '/api/v1/oauth/facebooks';

@withRouter
@inject('preloaderStore')
@inject('userStore')
@inject('alertStore')
export default class FacebookCallback extends React.Component {

  componentWillMount(){
    this.props.preloaderStore.activate();
    let hash = this.props.location.hash.replace('#','');
    let urlParams = new URLSearchParams(hash);
    let token = urlParams.get('access_token');
    new HttpClient().post(CREATE_USER, {token: token}).then(data => {
      const {token, user} = data.body.data;
      this.props.userStore.loginUser(user,token);
      this.props.alertStore.success('Successfully signed in')
      this.props.history.push('/dashboard')
    }).catch(data => {
      if(data.status === 422){
        this.props.history.push('/signUp');
        this.props.alertStore.error('Email has already taken')
      }
      else {
        this.props.history.push('/signUp');
        this.props.alertStore.error('Something went wrong')
      }
    })
  }

  componentWillUnmount(){
    this.props.preloaderStore.disable();
  }

  render(){
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/containers/oauth/FacebookCallback.js